import { useQuery } from "@tanstack/react-query";
import { Sparkle } from "@phosphor-icons/react";
import { VideoCard } from "@/components/VideoCard";
import { fetchPersonalized } from "@/lib/api";
import { getHistory } from "@/lib/watchHistory";
import { getSaved } from "@/lib/watchLater";

export const BecauseYouWatchedRow = () => {
  const seedId = getHistory()[0] || getSaved()[0] || null;

  const { data } = useQuery({
    queryKey: ["personalized", seedId],
    queryFn: () => fetchPersonalized(seedId, 12),
    enabled: !!seedId,
    staleTime: 60 * 1000,
  });

  const videos = data?.videos || [];
  if (!seedId || videos.length === 0) return null;

  return (
    <section className="mb-12" data-testid="because-you-watched-row">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-[#EDEDED] flex items-center gap-2.5">
          <Sparkle size={22} weight="fill" className="text-amber" />
          {data.context_title}
        </h2>
        <span
          data-testid="recency-pill"
          className="font-mono text-[10px] uppercase tracking-[0.15em] text-amber border border-amber/30 bg-amber/10 px-3 py-1"
        >
          Recently Imported First
        </span>
      </div>

      <div className="flex gap-4 rv-snap-row overflow-x-auto hide-scrollbar pb-2 -mx-1 px-1">
        {videos.map((v, i) => (
          <div key={v.video_id} className="rv-row-card w-[280px] sm:w-[320px] shrink-0">
            <VideoCard video={v} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
};
